//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../Routing/Routing.RouteObject.js";
let d=[[[0,"InterfaceTerminalShadow",0,"Routing.InterfaceTerminalShadow",0],[0,"Port",0,"Routing.Port",0]],[[["numberOfPorts"],"GetPorts",{R_:{ports:"Routing.Port[]"}},0,0],[["port"],"AddPort",{},1,0],[["port"],"RemovePort",{},1,0],[[],"ClearAllPorts",{},0,0],[[],"GetParentConnector",{R_:{connector:"Routing.SingleDevice"}},0,0]],[]];
SPLM.Routing.LogicalTerminal = class extends SPLM.Routing.RouteObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.LogicalTerminal";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;